import { Injectable, signal, computed } from '@angular/core';

export interface NavLink {
  readonly label: string;
  readonly path: string;
  readonly icon?: string;
  readonly openInNewTab?: boolean;
}

export interface NavSection {
  readonly label?: string;
  readonly links: readonly NavLink[];
}

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly _mobileNavOpen = signal(false);

  readonly navLinks: readonly NavLink[] = [
    { label: 'داشبورد', path: '/dashboard', icon: 'home-line' },
    { label: 'دسته‌بندی', path: '/categories', icon: 'grid-01' },
    { label: 'سفارشات من', path: '/orders', icon: 'receipt' },
    {
      label: 'پشتیبانی',
      path: 'https://zdsk.bacart.ir/',
      icon: 'headphones-01',
      openInNewTab: true,
    },
  ];

  readonly basketLink: NavLink = {
    label: 'سبد خرید',
    path: '/basket',
    icon: 'shopping-cart-03',
  };

  readonly accountLinks: readonly NavLink[] = [
    {
      label: 'احراز هویت',
      path: '/panel/kyc',
      icon: 'fingerprint-04',
    },
    {
      label: 'امنیت',
      path: '/panel/security',
      icon: 'shield-tick',
    },
    {
      label: 'کارت‌های بانکی',
      path: '/panel/bank-cards',
      icon: 'credit-card-02',
    },
    {
      label: 'کیف پول',
      path: '/panel/wallet',
      icon: 'wallet-02',
    },
    {
      label: 'تراکنش‌ها',
      path: '/panel/transactions',
      icon: 'credit-card-refresh',
    },
  ];

  /** Paths already available in the mobile bottom nav — omit from the side drawer. */
  private readonly _bottomNavPaths = new Set([
    '/dashboard',
    '/categories',
    '/basket',
    '/orders',
  ]);

  /**
   * Mobile hamburger drawer. Bottom-nav destinations are excluded so they are
   * not duplicated when the side nav is open on small screens. Support stays
   * last (immediately above logout in the template).
   */
  readonly mobileNavSections: readonly NavSection[] = [
    { label: 'حساب کاربری', links: this.accountLinks },
    {
      links: [...this.navLinks, this.basketLink].filter(
        (link) => !this._bottomNavPaths.has(link.path),
      ),
    },
  ];

  readonly mobileNavOpen = this._mobileNavOpen.asReadonly();
  readonly mobileNavClosed = computed(() => !this._mobileNavOpen());

  toggleMobileNav(): void {
    this._mobileNavOpen.update((open) => !open);
  }

  closeMobileNav(): void {
    this._mobileNavOpen.set(false);
  }

  openMobileNav(): void {
    this._mobileNavOpen.set(true);
  }
}
